import { useEffect } from "react";
  import { useLocation } from "react-router-dom";
  import { Box, CircularProgress, Typography } from "@mui/material";
  import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
  import theme from "../../theme/vs-theme";

  const AcceptMultipleInvitationPage = () => {
    const location = useLocation();

    useEffect(() => {
      const queryParams = new URLSearchParams(location.search);
      const redirectUrl = queryParams.get("redirect");

      if (redirectUrl) {
        const currentHost = window.location.origin;
        const apiPath = '/institutions/v1' + redirectUrl;
        const finalUrl = currentHost + apiPath;

        console.log("Redirecting to multiple invitations:", finalUrl);
        window.location.href = finalUrl;
      }
    }, [location]);

    return (
      <MuiThemeProvider theme={theme}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="100vh"
          padding={3}
        >
          <CircularProgress size={60} />
          <Typography variant="h6" sx={{ mt: 2 }}>
            Procesando invitaciones múltiples...
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, textAlign: "center" }}>
            Redirigiendo para validar todas las invitaciones pendientes
          </Typography>
        </Box>
      </MuiThemeProvider>
    );
  };

  export default AcceptMultipleInvitationPage;